import heroRoom from './../assets/images/Functions/heroRoom.webp'

const EventsHero = () => {
  const scrollToContactForm = () => {
    const contactForm = document.getElementById('ContactForm');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='w-full h-[90vh] relative mb-16'>
      <div className="absolute top-0 left-0 w-full h-[90vh] bg-cover lg:bg-fixed md:bg-fixed" style={{
          backgroundImage: `url(${heroRoom})`,
          backgroundPosition: 'center'
        }} />
      <div className="absolute inset-0 bg-black opacity-40"/>
      <div className='bg-black/30 absolute top-0 left-0 w-full h-[90vh] z-10'/>
        <div className='absolute top-16 w-full h-full flex flex-col justify-center text-white text-center z-20'>
            <div className='md:left-[10%] md:right-[10%] max-w-[1100px] m-auto absolute p-4'>
                <div className='flex justify-center'>
                    <h1 className='font-bold text-5xl md:text-7xl drop-shadow-2xl'>Private Events at The Fox</h1>
                </div>
                <p className='drop-shadow-2xl py-4 text-xl'>Our charming venue, rich in character with many original features, boasts a spacious function suite that seamlessly extends onto a stunning sun terrace, offering breathtaking views of the surrounding landscape. The suite comfortably accommodates 150–200 guests and features a private bar, a dedicated stage area for entertainment, and a beautifully designed decking area, perfect for outdoor socializing.</p>
                <button onClick={scrollToContactForm} className='bg-white text-black border-2 border-black px-4 py-1 rounded-full font-bold hover:bg-black hover:text-white transition-all duration-300'>Book A Meeting</button>
            </div>
        </div>
    </div>
  )
}

export default EventsHero
